import { useMemo } from 'react';

import { TArrayFilters } from 'appTypes';

import { SortOrder, sortByDate } from '../utils';

export const useFilteredArrayOfObjects = (
  arr: any[],
  accessor: string | undefined,
  filters: TArrayFilters,
  sort?: string,
  sortOrder?: number,
  stats?: Record<string, any>,
  dateSort: boolean = false,
) => {
  return useMemo(() => {
    if (!arr || arr.length === 0) return [];

    let filtered = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value === undefined) return acc;
      if (typeof value === 'string')
        return acc.filter((el) =>
          (accessor === undefined ? el : el?.[accessor])?.[key]
            ?.toLowerCase()
            .includes(value),
        );
      else
        return acc.filter(
          (el) =>
            (accessor === undefined ? el : el?.[accessor])?.[key] === value,
        );
    }, arr);

    if (sort && sortOrder !== 0) {
      if (dateSort)
        filtered = sortByDate(
          filtered,
          sort,
          sortOrder === -1 ? SortOrder.DESC : SortOrder.ASC,
        );
      else {
        filtered.sort((a, b) => {
          const valA =
            stats?.[a.id]?.[sort] ??
            (accessor === undefined ? a : a?.[accessor])?.[sort];
          const valB =
            stats?.[b.id]?.[sort] ??
            (accessor === undefined ? b : b?.[accessor])?.[sort];

          const aStr =
            typeof valA === 'string' || typeof valA === 'number'
              ? valA
              : String(valA);
          const bStr =
            typeof valB === 'string' || typeof valB === 'number'
              ? valB
              : String(valB);

          if (aStr > bStr) return sortOrder;
          if (aStr < bStr) return -sortOrder;
          return 0;
        });
      }
    }
    return filtered;
  }, [arr, filters, sort, sortOrder, stats]);
};
